import React from 'react';

const AdminSettings = ({ settings, setSettings, handleSettingsSubmit, loading }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Auto-generate messaging links but keep them editable
      const cleaned = value.replace(/\+/g, '').replace(/\s/g, '').replace(/^00/, '');
      setSettings(prev => ({ 
        ...prev, 
        [name]: value,
        viber: cleaned ? `viber://contact?number=${cleaned}` : prev.viber,
        whatsapp: cleaned ? `https://wa.me/${cleaned}` : prev.whatsapp
      }));
    } else {
      setSettings(prev => ({ ...prev, [name]: value }));
    }
  };

  if (loading) return <div>Učitavanje postavki...</div>;

  return (
    <div className="max-w-4xl mx-auto p-6 font-sans">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex items-center gap-4">
          <button 
            onClick={() => window.history.back()} 
            className="w-fit flex items-center gap-1.5 text-black font-bold uppercase tracking-[0.2em] text-[10px] transition-all bg-white px-3 py-2 rounded-lg border border-gray-100 hover:bg-black hover:text-white"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
            </svg>
            Nazad
          </button>
          <div className="flex-1">
            <h2 className="text-xl font-black text-black tracking-tight">Globalne Postavke</h2>
          </div>
        </div>
        
        <form onSubmit={handleSettingsSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Email */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">Email Adresa</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-black">
                  <i className="fas fa-envelope"></i>
                </span>
                <input
                  type="email"
                  name="email"
                  value={settings.email || ''}
                  onChange={handleChange}
                  placeholder="info@nejirazukic.com"
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* Phone */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">Broj Telefona</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-black">
                  <i className="fas fa-phone"></i>
                </span>
                <input
                  type="text"
                  name="phone"
                  value={settings.phone || ''}
                  onChange={handleChange}
                  placeholder="+387 61 000 000"
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* Instagram */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">Instagram URL</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-black">
                  <i className="fab fa-instagram"></i>
                </span>
                <input
                  type="text"
                  name="instagram"
                  value={settings.instagram || ''}
                  onChange={handleChange}
                  placeholder="https://instagram.com/..."
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* YouTube */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">YouTube URL</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-black">
                  <i className="fab fa-youtube"></i>
                </span>
                <input
                  type="text"
                  name="youtube"
                  value={settings.youtube || ''}
                  onChange={handleChange}
                  placeholder="https://youtube.com/..."
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* Viber */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">Viber Broj (ili Link)</label>
              <div className="relative">
                <input
                  type="text"
                  name="viber"
                  value={settings.viber || ''}
                  onChange={handleChange}
                  placeholder="viber://contact?number=..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* WhatsApp */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">WhatsApp Broj/Link</label>
              <div className="relative">
                <input
                  type="text"
                  name="whatsapp"
                  value={settings.whatsapp || ''}
                  onChange={handleChange}
                  placeholder="https://wa.me/..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* Address */}
            <div className="col-span-full space-y-2">
              <label className="block text-sm font-medium text-black">Adresa / Lokacija</label>
              <input
                type="text"
                name="address"
                value={settings.address || ''}
                onChange={handleChange}
                placeholder="Sarajevo, Bosna i Hercegovina"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
              />
            </div>

            {/* Facebook */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">Facebook URL</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-black">
                  <i className="fab fa-facebook"></i>
                </span>
                <input
                  type="text"
                  name="facebook"
                  value={settings.facebook || ''}
                  onChange={handleChange}
                  placeholder="https://facebook.com/..."
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>

            {/* TikTok */}
            <div className="space-y-2">
              <label className="block text-sm font-medium text-black">TikTok URL</label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-black">
                  <i className="fab fa-tiktok"></i>
                </span>
                <input
                  type="text"
                  name="tiktok"
                  value={settings.tiktok || ''}
                  onChange={handleChange}
                  placeholder="https://tiktok.com/@..."
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>
          </div>

          {/* Branding & content moved to Section settings — removed from global settings UI */}

          {/* TELEGRAM NOTIFICATIONS SECTION */}
          <div className="pt-6 border-t border-gray-100">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-black">Telegram Obavijesti</h3>
              <p className="text-sm text-black">Testirajte slanje obavijesti na Telegram (konfigurisano u .env fajlu)</p>
            </div>

            <div className="flex items-center gap-4">
              <button
                type="button"
                onClick={() => {
                  const botToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
                  const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;
                  
                  if (!botToken || botToken.includes('your_')) {
                    alert('Telegram podaci nisu konfigurisani u .env fajlu!');
                    return;
                  }
                  
                  const telegramText = `🤖 *Testna poruka*\nUspješno ste povezali Telegram bot sa vašom web stranicom!`;
                  
                  fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      chat_id: chatId,
                      text: telegramText,
                      parse_mode: 'Markdown'
                    })
                  })
                  .then(res => res.json())
                  .then(data => {
                    if (data.ok) alert('✅ Testna poruka poslana na Telegram!');
                    else alert('❌ Greška: ' + data.description);
                  })
                  .catch(err => alert('❌ Problem sa konekcijom.'));
                }}
                className="px-6 py-2.5 bg-[#1a4d2e] text-white rounded-lg hover:bg-black transition-all text-[10px] font-bold uppercase tracking-widest shadow-sm"
              >
                Pošalji Test Poruku
              </button>
            </div>
          </div>

          {/* SEO SECTION */}
          <div className="pt-6 border-t border-gray-100">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-black">SEO Optimizacija</h3>
              <p className="text-sm text-black">Kako se vaša stranica pojavljuje na Google pretraživaču</p>
            </div>

            <div className="space-y-4">
              <div className="space-y-2">
                <label className="block text-sm font-medium text-black">SEO Naslov (Meta Title)</label>
                <input
                  type="text"
                  name="seoTitle"
                  value={settings.seoTitle || ''}
                  onChange={handleChange}
                  placeholder="Maksimalno 60 karaktera"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-black">SEO Opis (Meta Description)</label>
                <textarea
                  name="seoDescription"
                  rows="3"
                  value={settings.seoDescription || ''}
                  onChange={handleChange}
                  placeholder="Maksimalno 160 karaktera. Kratak opis šta radite."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-black">Ključne riječi (Keywords)</label>
                <input
                  type="text"
                  name="seoKeywords"
                  value={settings.seoKeywords || ''}
                  onChange={handleChange}
                  placeholder="wedding, photographer, sarajevo, ..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                />
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-100 flex justify-end">
            <button
              type="submit"
              className="w-fit bg-black text-white hover:bg-gray-800 px-8 py-3 rounded-lg text-[11px] font-bold uppercase tracking-[0.2em] transition-all shadow-sm"
            >
              Spremi Postavke
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;
